import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';
import { PermissionAction } from 'src/actions/permission.acction';
import { Goicuoc5gAction } from 'src/actions/goicuoc5g.action';

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    TextField,
    Typography,
    Grid,
    Box,
    Select as Select1,
    InputAdornment,
    SvgIcon,
    MenuItem,
} from '@material-ui/core';

import { Search as SearchIcon } from 'react-feather';

import {
    DatePicker,
    LocalizationProvider,
  } from '@mui/x-date-pickers';
  import {
    DEFAULT_ROW_PER_PAGE,
    LOAI_GOI_CUOC,
    POST_EDITOR_FONTS,
    POST_EDITOR_FONT_SIZES,
    OPERATOR_THEME,
    CU_PHAP_DANG_KY_GOI_CUOC,
  } from 'src/utils/constants';
  import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';

import { Helmet } from "react-helmet";

import PostEditor from "../../components/PostEditor";
import ImageUploader from "../../components/ImageUploader";

const DangKyGoiCuocDialog = (props) => {
    const dispatch = useDispatch()
    const [selectedPermissionIds, setSelectedPermissionIds] = useState([]);
    const { role } = useSelector(state => state.profile);
    const { items } = useSelector(state => state.permission)
    const { homepageGoicuoc5gSelected } = useSelector(state => state.goicuoc5g)

    const [operatorTheme, setOperatorTheme] = useState(null);

    const [name, setName] = useState("");
    const [price, setPrice] = useState(0);
    const [price_new, setPriceNew] = useState(0);
    const [operator, setOperator] = useState("-99");
    const [number_type, setNumberType] = useState("-99");
    const [loai_goi_cuoc, setLoaiGoiCuoc] = useState({});
    const [time_by_day, setTimeByDay] = useState(0);
    const [tam_dung, setTamDung] = useState("-99");
    const [short_description, setShortDescription] = useState("");
    const [description, setDescription] = useState("");
    const [cu_phap, setCuPhap] = useState([]);

    const [phone, setPhone] = useState('');
    const [otp, setOtp] = useState('');

    const danhSachLoaiGoiCuoc = LOAI_GOI_CUOC;

    useEffect(() => {
        if (items.length > 0) {
            return;
        }
    }, [])

    useEffect(() => {
        resetState();
        if (props.type === 'EDIT') {
            if (homepageGoicuoc5gSelected) {
                setName(homepageGoicuoc5gSelected.name)
                setPrice(homepageGoicuoc5gSelected.price)
                setPriceNew(homepageGoicuoc5gSelected.price_new)
                setOperator(homepageGoicuoc5gSelected.operator)
                setNumberType(homepageGoicuoc5gSelected.number_type)
                setTimeByDay(homepageGoicuoc5gSelected.time_by_day)
                setTamDung(homepageGoicuoc5gSelected.tam_dung.toString())
                setShortDescription(homepageGoicuoc5gSelected.short_description)
                setDescription(homepageGoicuoc5gSelected.description)
                
                setCuPhap([])

                if (homepageGoicuoc5gSelected.name && homepageGoicuoc5gSelected.operator && typeof CU_PHAP_DANG_KY_GOI_CUOC[homepageGoicuoc5gSelected.operator.trim().toLowerCase()] !== 'undefined') {
                  let _operator = homepageGoicuoc5gSelected.operator.trim().toLowerCase();
                  let _ten_goi_cuoc = homepageGoicuoc5gSelected.name.trim();
                  let _cu_phap_raw = CU_PHAP_DANG_KY_GOI_CUOC[_operator];
                  setCuPhap(_cu_phap_raw.map(item => ({
                    ...item,
                    cu_phap_sms: item.cu_phap.replace("<TÊN_GÓI>", _ten_goi_cuoc),
                  })));
                  setOperatorTheme(typeof OPERATOR_THEME[_operator] !== 'undefined' ? OPERATOR_THEME[_operator] : null);
                }

                setLoaiGoiCuoc({})

                if (homepageGoicuoc5gSelected.types && Object.keys(homepageGoicuoc5gSelected.types).length > 0) {
                    let inputLoaiGoiCuoc = {};

                    Object.entries(homepageGoicuoc5gSelected.types).forEach(([key, value]) => {
                        inputLoaiGoiCuoc[value.loai_goi_cuoc] = 1;
                    });

                    setLoaiGoiCuoc(inputLoaiGoiCuoc);
                }
            }
        }
    }, [homepageGoicuoc5gSelected])

    const onPressPositive = async () => {
        console.log("description:", description);

        if (name === "") {
            alert("Những trường * là bắt buộc");
            return;
        }
        if (price === "") {
            alert("Những trường * là bắt buộc");
            return;
        }
        if (operator === "" || operator == "-99") {
            alert("Những trường * là bắt buộc");
            return;
        }
        if (number_type === "" || number_type == "-99") {
            alert("Những trường * là bắt buộc");
            return;
        }
        if (time_by_day === "") {
            alert("Những trường * là bắt buộc");
            return;
        }
        if (tam_dung === "" || tam_dung == "-99") {
            alert("Những trường * là bắt buộc");
            return;
        }
        if (short_description === "") {
            alert("Những trường * là bắt buộc");
            return;
        }
        if (description === "") {
            alert("Những trường * là bắt buộc");
            return;
        }

        let outputLoaiGoiCuoc = [];

        if (Object.keys(loai_goi_cuoc).length > 0) {
            Object.entries(loai_goi_cuoc).forEach(([key, value]) => {
                if (value == 1) {
                    outputLoaiGoiCuoc.push(key);
                }
            });
        }

        if (outputLoaiGoiCuoc.length < 1) {
            alert('Vui lòng chọn ít nhất 1 loại gói cước!');
            return;
        }

        if (props.type === 'EDIT') {
            dispatch(Goicuoc5gAction.update(homepageGoicuoc5gSelected.id, { 
                name,
                price,
                price_new,
                operator, 
                number_type,
                loai_goi_cuoc: outputLoaiGoiCuoc,
                time_by_day,
                tam_dung,
                short_description,
                description,
            }))
            resetState();
            props.handleClose();
        } else {
            try {
                const response = await dispatch(Goicuoc5gAction.create({ 
                    name,
                    price,
                    price_new,
                    operator, 
                    number_type,
                    loai_goi_cuoc: outputLoaiGoiCuoc,
                    time_by_day,
                    tam_dung,
                    short_description,
                    description,
                }))
                resetState();
                props.handleClose();
            } catch (error) {
                if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
            }
        }
        
    }

    const resetState = () => {
        setName("")
        setPrice(0)
        setPriceNew(0)
        setOperator("-99")
        setNumberType("-99")
        setLoaiGoiCuoc({})
        setTimeByDay(0)
        setTamDung("-99")
        setShortDescription("")
        setDescription("")
        setCuPhap([]);
    }

    const chonLoaiGoiCuoc = (e, value) => {
        setLoaiGoiCuoc({
            ...loai_goi_cuoc,
            [value]: e.target.value == 1 ? 2 : 1
        })
    }

    const setColor = (value) => {
        if (value == 'MOBIFONE') return 'green';
        else if (value == 'VINAPHONE') return 'blue';
        else if (value == 'VIETTEL') return 'red';
        else return '#000000';
    };

    const onRequestOtp = (phone) => {
  
    };

    const onRegister = (phone, otp) => {
  
    };

    return (<>
        <Helmet>
            <style>{`
                .otp-close-btn {
                  position: absolute;
                  top: 12px;
                  right: 12px;
                  background-color: red;
                  color: white;
                  border: none;
                  border-radius: 50%;
                  width: 32px;
                  height: 32px;
                  font-size: 20px;
                  font-weight: bold;
                  line-height: 32px;
                  text-align: center;
                  cursor: pointer;
                  z-index: 10;
                }

                .otp-container {
                  width: 100%;
                  max-width: 480px;
                  margin: auto;
                  padding: 16px;
                  box-sizing: border-box;
                  font-family: Mulish, sans-serif;
                }
                
                .otp-title {
                  text-align: center;
                  margin-bottom: 20px;
                  font-size: 20px;
                  color: #007bff;
                }
                
                .otp-group {
                  margin-bottom: 16px;
                }
                
                .otp-label {
                  display: block;
                  font-weight: 600;
                  margin-bottom: 6px;
                }
                
                .otp-required {
                  color: red;
                }
                
                .otp-input-row {
                  display: flex;
                  align-items: center;
                  gap: 8px;
                }
                
                .otp-icon {
                  font-size: 20px;
                  color: #555;
                }
                
                .otp-input {
                  flex: 1;
                  padding: 8px;
                  font-size: 16px;
                  border: 1px solid #ccc;
                  border-radius: 4px;
                }
                
                .otp-btn {
                  padding: 8px 10px;
                  background-color: var(--main-color);
                  color: white;
                  border: none;
                  border-radius: 4px;
                  font-size: 14px;
                  cursor: pointer;
                  white-space: nowrap;
                  height: 36px;
                  min-width: 80px;
                }
                
                .otp-btn.resend {
                  background-color: #eefbff;
                  color: var(--main-color);
                  border: 1px solid var(--main-color);
                  height: 36px;
                  min-width: 80px;
                }
                
                .otp-submit {
                  text-align: center;
                  margin-top: 20px;
                }
                
                .otp-submit-btn {
                  padding: 10px 25px;
                  background-color: #007bff;
                  border: none;
                  color: white;
                  font-weight: bold;
                  border-radius: 6px;
                  font-size: 16px;
                  cursor: pointer;
                }
                
                .otp-warning {
                  margin-top: 12px;
                  text-align: center;
                  font-weight: 600;
                  font-size: 14px;
                }

                .cu-phap-btn {
                  display: block;
                  text-align: center;
                  align-items: center;
                  gap: 8px;
                  background-color: #4CAF50;
                  color: white;
                  padding: 12px 18px;
                  margin: 8px;
                  text-decoration: none;
                  border-radius: 8px;
                  font-weight: bold;
                  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
                  transition: background-color 0.2s ease, transform 0.1s ease;
                }
                
                .cu-phap-btn:hover {
                  background-color: #45a049;
                  transform: scale(1.03);
                }
                
                /* Mobile responsive */
                @media screen and (max-width: 480px) {
                  .otp-input-row {
                    flex-direction: column;
                    align-items: stretch;
                  }
                
                  .otp-btn {
                    width: 100%;
                    margin-top: 6px;
                  }
                
                  .otp-btn.resend {
                    width: 100%;
                    margin-top: 6px;
                  }
                }                
            `}</style>
        </Helmet>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Dialog style={{zIndex: 999999}} open={props.open} onClose={props.handleClose}>
                {/* <DialogTitle>{props.type === 'EDIT' ? "Cập nhật bản ghi" : "Tạo bản ghi mới"}</DialogTitle> */}
                <DialogContent style={{ width: 600, paddingTop: 20 }}>
                  <div className="otp-container">
                    {/* Nút đóng */}
                    <button className="otp-close-btn" onClick={props.handleClose}>
                      &times;
                    </button>

                    <h3 style={{color: operatorTheme && typeof operatorTheme['primary'] !== 'undefined' ? operatorTheme['primary'] : '#000000'}} className="otp-title">Xác nhận đăng ký {name}</h3>

                    <div style={{width: 'max-content', margin: 'auto'}}>
                      {cu_phap && cu_phap.map((item, index) => (
                        <a style={{backgroundColor: operatorTheme && typeof operatorTheme['primary'] !== 'undefined' ? operatorTheme['primary'] : '#000000'}} className='cu-phap-btn' href={`sms:${item.so_nhan}?&body=${encodeURIComponent(item.cu_phap_sms)}`}>{item.cu_phap_sms} <span style={{color: 'yellow'}}>gửi</span> {item.so_nhan}</a>
                      ))}
                    </div>
                  </div>
                </DialogContent>
                {/* <DialogActions>
                    <Button onClick={props.handleClose}>Huỷ</Button>
                    <Button onClick={onPressPositive}>{props.type === 'EDIT' ? "Cập nhật" : "Tạo"}</Button>
                </DialogActions> */}
            </Dialog >
        </LocalizationProvider>
    </>);
}

export default DangKyGoiCuocDialog;